import FormWrapper from 'components/Form/FormWrapper'
import styled from 'styled-components'
import HistoryTable from './components/HistoryTable'
import FilterForm from './components/FilterForm'
import { useCallback, useEffect, useState } from 'react'
import { supportService } from 'services'
import * as qs from 'query-string'
import { useHistory } from 'react-router-dom'

const WrapperPage = styled.div`
  min-height: 77vh;
  width: 100%;
  padding: 0 20px 40px;
  display: flex;
  flex-direction: column;
`

const Page = () => {
  const history = useHistory()

  const [dataList, setDataList] = useState<any>()
  const [loadingList, setLoadingList] = useState<boolean>(false)
  const [params, setParams] = useState<any>(() => {
    const query = qs.parse(location.search)
    return {
      page: Number(query.page) || 1,
      per_page: Number(query.per_page) || 25,
      order_code: query.order_code || undefined,
      status: Number(query.status) || undefined,
    }
  })

  useEffect(() => {
    const query = qs.parse(location.search)
    setParams({
      page: Number(query.page) || 1,
      per_page: Number(query.per_page) || 25,
      order_code: query.order_code || undefined,
      status: Number(query.status) || undefined,
    })
  }, [])
  useEffect(() => {
    if (params) {
      const queryString = qs.stringify(params)
      history.push({
        pathname: history.location.pathname,
        search: queryString ? `?${queryString}` : '',
      })
    }
  }, [history, params])
  const searchSupport = useCallback(() => {
    if (params) {
      supportService.search(params, (data) => {
        setDataList(data)
        setLoadingList(false)
      })
    }
  }, [params])

  useEffect(() => {
    searchSupport()
  }, [searchSupport])

  return (
    <WrapperPage>
      <p className='title-page'>Hỗ trợ khách hàng</p>

      <FormWrapper>
        <FilterForm setParams={setParams} setLoadingList={setLoadingList} loadingList={loadingList} params={params} />
        <HistoryTable dataList={dataList} setParams={setParams} />
      </FormWrapper>
    </WrapperPage>
  )
}

export default Page
